import * as _ from 'underscore';

import { Order } from '../../ts/helpers/Order';
import { ContentFiltersKeys } from '../../ts/models/ContentFilters';
import { OrderKeys } from '../../ts/models/OrderKeys';
import { IContentType, ViewStatFields } from '../../ts/models/ContentTypes';

export const MetricContentType: IContentType = {
  name: 'metric',
  filterKeys: _.compact([
    ContentFiltersKeys.search,
    ContentFiltersKeys.favorite,
    ContentFiltersKeys.project,
    ContentFiltersKeys.owner,
    ContentFiltersKeys.tag,
    ContentFiltersKeys.modifiedAfter,
    ContentFiltersKeys.modifiedBefore,
    ContentFiltersKeys.createdAfter,
    ContentFiltersKeys.createdBefore,
    ContentFiltersKeys.recent
  ]),
  canShowFilterPanel: true,
  orderKeys: [
    OrderKeys.name,
  ],
  extraQueryParams: {
    statFields: ViewStatFields
  },
  defaultOrder: [Order.asc(OrderKeys.name)],
};
